export enum ECurrency {
    DOLLAR,
    EURO
}